var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container",attrs:{"id":_vm.id}},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})])}
var staticRenderFns = []

export { render, staticRenderFns }